import { render, staticRenderFns } from "./MarketMover.vue?vue&type=template&id=20ecf08c&scoped=true"
import script from "./MarketMover.vue?vue&type=script&lang=js"
export * from "./MarketMover.vue?vue&type=script&lang=js"
import style0 from "./MarketMover.vue?vue&type=style&index=0&id=20ecf08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ecf08c",
  null
  
)

export default component.exports